import sanBaoErrorSign from './sanBaoErrorSign.js'


// 定制逻辑处理
export default {
  ...sanBaoErrorSign
}